import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { FlexBenefitListItemExtension } from './flex-benefit-list-item.extension';
import { FlexBenefitMetadataExtension } from './flex-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('flex')
    .add(BenefitMetadataExtensionInterface, new FlexBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new FlexBenefitListItemExtension())
    .build(),
);
